<p
  [id]="actionTextContentModel?.id"
  [style.font-family]="actionTextContentModel?.fontFamily"
  [style.font-weight]="actionTextContentModel?.fontWeight"
  [style.font-size.px]="actionTextContentModel?.fontSize"
  [style.line-height.px]="actionTextContentModel?.lineHeight"
  [style.color]="actionTextContentModel?.color"
  [style.margin-bottom]="actionTextContentModel?.marginBottom"
  [style.margin-top]="actionTextContentModel?.marginTop"
  [style.margin-left]="actionTextContentModel?.marginLeft"
  [style.margin-right]="actionTextContentModel?.marginRight"
  [class]="
    (!!actionTextContentModel?.fontTypeKey
      ? 'font-' + actionTextContentModel?.fontTypeKey
      : 'pg-text-content') + ' pg-action-text-content'
  "
>
  <ng-container *ngIf="actionTextContentModel?.actionPosition === 'before'">
    <a
      (click)="handleActionClicked()"
      class="action-text-content--action__before"
      >{{ actionTextContentModel?.actionContent }}</a
    >
  </ng-container>
  <span [innerHTML]="actionTextContentModel?.content"> </span>
  <ng-container *ngIf="actionTextContentModel?.actionPosition === 'after'">
    <a
      (click)="handleActionClicked()"
      class="action-text-content--action__after"
      >{{ actionTextContentModel?.actionContent }}</a
    >
    <div
      class="action-text-content--spinner__wrapper"
      *ngIf="actionTextContentModel?.loading"
    >
      <pg-spinner
        class="action-text-content--spinner"
        [size]="getSpinnerSize()"
        [strokeWidth]="getSpinnerStrokeWidth()"
      ></pg-spinner>
    </div>
    <pg-icon
      color="success"
      [size]="getIconFontSize()"
      *ngIf="actionTextContentModel?.success"
      class="action-text-content--success-action-icon"
      >done</pg-icon
    >
  </ng-container>
</p>
